<ng-container>
  <div class="service-img">
    <img [alt]="item().title | trans" [src]="imgPath()" />
  </div>

  <div class="service-content">
    <h4 [title]="item().title | trans" class="service-title">
      {{ item().title | trans }}
    </h4>

    <h6 [title]="item().category?.title | trans" class="service-category">
      {{ item().category?.title | trans }}
    </h6>

    <div [renderHtml]="item().shortDescription" class="service-text"></div>

    <div class="service-see-more-container">
      <a
        [title]="'See more' | trans"
        [routerLink]="['/services', item().category?.slug, item().slug]"
        class="service-see-more"
      >
        {{ 'See more' | trans }}

        <fa-icon [icon]="icons['seeMore']" />
      </a>
    </div>
  </div>
</ng-container>
